import { readonly } from 'vue'
import { storeToRefs } from 'pinia'
import { logService } from '@nsftx/seven-client-retail-utils'
import deviceManagementTokenApiService from './deviceManagementTokenApiService'
import { useDeviceManagementTokenStore } from '../stores/deviceManagementTokenStore'
import errorParser from '#src/common/error-handling/errorParser'

const LOG_PREFIX = '[deviceManagementTokenService]'

const setDeviceAccessToken = async () => {
  const { accessToken } = storeToRefs(useDeviceManagementTokenStore())

  try {
    accessToken.value = await deviceManagementTokenApiService.getAccessToken()
  } catch (error) {
    logService.error(`${LOG_PREFIX} Failed to set device access token.`, {
      ...errorParser.parseUpstream(error),
      code: 'DM_TOKEN_SET_DEVICE_ACCESS_TOKEN_FAILED'
    })
    throw error
  }
}

const getDeviceAccessToken = () => {
  const { accessToken } = storeToRefs(useDeviceManagementTokenStore())

  return readonly(accessToken)
}

const handleDeviceAccessTokenChange = async (
  updateSource: 'coreReadyEvent' | 'tokenUpdateEvent'
) => {
  const isCoreReadyEvent = updateSource === 'coreReadyEvent'
  const logDetails = {
    successMessage: `${LOG_PREFIX} Device access token successfully set on ${isCoreReadyEvent ? 'core ready' : 'token update'} event.`,
    errorMessage: `${LOG_PREFIX} Failed to set device access token on ${isCoreReadyEvent ? 'core ready' : 'token update'} event.`,
    successCode: isCoreReadyEvent
      ? 'DM_CORE_SET_DEVICE_ACCESS_TOKEN_INIT_SUCCESS'
      : 'DM_CORE_SET_DEVICE_ACCESS_TOKEN_REFRESH_SUCCESS',
    errorCode: isCoreReadyEvent
      ? 'DM_CORE_SET_DEVICE_ACCESS_TOKEN_INIT_FAILED'
      : 'DM_CORE_SET_DEVICE_ACCESS_TOKEN_REFRESH_FAILED'
  }

  try {
    await setDeviceAccessToken()
    logService.info(logDetails.successMessage, {
      code: logDetails.successCode
    })
  } catch (error) {
    logService.warn(logDetails.errorMessage, {
      code: logDetails.errorCode,
      ...errorParser.parseUpstream(error)
    })
  }
}

export { getDeviceAccessToken, handleDeviceAccessTokenChange, setDeviceAccessToken }
